import React from 'react';
import { Action, withInject } from '@piwikpro/platform';
import { TFunction } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import {
  Stack,
  Text,
  withTranslation,
} from '@piwikpro/ui-components';
import { Apps } from '@piwikpro/apps-crate';
import { AdministrationState, STATE_ROOT } from '../../../../../redux';

const mapStateToProps = (state: AdministrationState) => {
  const { settings } = state[STATE_ROOT].apps.details.settings;

  return {
    app: settings as NonNullable<typeof settings>,
  };
};

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  apps: Apps
}

interface Props extends ReduxProps, InjectedProps {
  t: TFunction
}

class CnilCompliance extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values, { setFieldValue, setSubmitting }) {
    const { apps, app } = this.props;

    try {
      await apps.update(app.id, values);
    } catch (err) {
      setFieldValue('cnil', !values.cnil, false);
    }

    setSubmitting(false);
  }

  render() {
    const {
      app,
      t,
    } = this.props;

    return (
      <Stack wrap verticalAlignment="center">
        <Stack.Item fill>
          <Stack vertical spacing="narrow">
            <Stack.Item>
              <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.cnilCompliance.title')}</Text>
            </Stack.Item>
            <Stack.Item>
              <Text as="p">{t('apps.details.settings.cnilCompliance.description')}</Text>
              <Text as="p">{t('apps.details.settings.cnilCompliance.session-log-info')}</Text>
            </Stack.Item>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Action.AutoSavedSwitcherControl
            id="app-settings-cnil-compliance"
            initialValue={app.attributes.cnil}
            name="cnil"
            onSubmit={this.handleSubmit}
          />
        </Stack.Item>
      </Stack>
    );
  }
}

export default connector(withInject<InjectedProps>({
  apps: 'AppsCrate.apps',
})(
  withTranslation(['administration'])(CnilCompliance),
));
